import React, { useState } from 'react'
import { Modal, Form, Input, Button } from 'antd'

const { TextArea } = Input

const RejectCommissionModal = (props) => {
    const { visible, handleCancel, handleReject, commissionId, isSubmit } = props
    const [form] = Form.useForm()
    const [rejectionReason, setRejectionReason] = useState('')
    
    const onFinish = () => {
        handleReject(commissionId, rejectionReason)
    }
    
    const onCancel = () => {
        form.resetFields()
        setRejectionReason('')
        handleCancel()
    }
    
    return (
        <Modal
            visible={visible}
            title="Rejeitar Comissão"
            onCancel={onCancel}
            centered
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    onClick={() => form.submit()} 
                    loading={isSubmit}
                    danger
                >
                    Rejeitar
                </Button>,
            ]}
        >
            <div className="deny-info-wrapper">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="rejectionReason"
                        label="Motivo da Rejeição"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor, informe o motivo da rejeição',
                            },
                        ]}
                    >
                        <TextArea 
                            rows={4} 
                            placeholder="Informe o motivo da rejeição da comissão"
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                        />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    )
}

export default RejectCommissionModal 